import { format } from "date-fns";

export interface IDateUtils {
  getCurrentYear: () => string;
}

export const DateUtils: IDateUtils = {
  getCurrentYear: () => {
    return format(new Date(), "yyyy");
  },
};
